import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/activitylog";
const API_PATH_EXT = ConstantList.API_EN_POINT + "/activity-log-emr";

export const pagingActivityLog = (obj) => axios.get(API_PATH + "/" + obj?.pageIndex + "/" + obj?.pageSize);

export const getActivityLogById = (visitTypeId) => axios.get(API_PATH_EXT + "/" + visitTypeId);
export const pagingActivityLogByEmr = (obj) => axios.post(API_PATH_EXT + "/search-by-page-emr", obj);
